



































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
@Component({
  name: "riskReporting"
})
export default class RiskReporting extends Vue {
  @Prop() ticketData!: any; // 工单信息
  @Prop() riskReportList!: any[]; // 风险原因列表
  @Prop() resCallObj!: any[]; // 联系人关系列表
  @Prop() contactList!: any[]; // 联系人列表
  @Prop() type!: string; // 催收类型
  // @Prop() defaultTime!: string; // 拨打时间默认值，在页面中拨打操作回显
  // @Prop() defaultCaller!: string; // 拨打对象默认值，在页面中拨打操作回显
  // @Prop() defaultCallerjPhone!: string; // 拨打对象手机号默认值，在页面中拨打操作回显
  @Provide() private riskReportingForm: any = {
    phoneObject: null,
    // phoneObject: this.defaultCaller ? this.defaultCaller : null,
    // phoneCallInput: this.defaultCallerjPhone ? this.defaultCallerjPhone : null,
    phoneConnected: null,
    phoneTime: null,
    riskReport: []
  };
  @Provide() private msg: any = this.$message;
  @Provide() private isSaved: any = false;
  // 点击关闭弹窗
  private hideContainer() {
    this.$emit("returnRiskReport", {
      isShow: true
    });
  }
  // 风险上报操作
  private saveRiskReportJudgement() {
    if (
      this.riskReportingForm.phoneTime &&
      this.riskReportingForm.riskReport.length &&
      this.riskReportingForm.phoneObject &&
      this.riskReportingForm.phoneConnected
    ) {
      this.isSaved = true;
      return true;
    }
    return false;
  }
  private async saveRiskReport() {
    if (this.saveRiskReportJudgement()) {
      let arg = {
        UrgeType: this.type === "repay" ? 1 : 2,
        ItemId: this.ticketData.itemid,
        CaseId: this.ticketData.relatedid,
        PhoneObject: this.riskReportingForm.phoneObject,
        OrderId: this.ticketData.orderid, // 订单ID [jstype = JS_STRING];
        // phoneCallInput: "",
        // phoneObject: this.defaultCaller ? this.defaultCaller : null,
        // phoneCallInput: this.defaultCallerjPhone
        //   ? this.defaultCallerjPhone
        //   : null,
        PhoneConnected: Number(this.riskReportingForm.phoneConnected),
        PhoneTime: this.riskReportingForm.phoneTime,
        RiskReport: this.riskReportingForm.riskReport.join(",")
      };
      const { saveRiskReport }: any = await import("@/request/saveRiskReport");
      let res = await saveRiskReport(arg, this);
      if (res) {
        this.isSaved = res.loading ? res.loading : false;
        if (res.commonout.code === 0) {
          this.msg({
            type: "success",
            message: res.errmsg ? res.errmsg : "save success!"
          });
          this.hideContainer();
        }
      } else {
        this.isSaved = false;
      }
    } else {
      this.isSaved = false;
      this.$message({
        type: "error",
        message: "pls check the form value!"
      });
    }
  }
}
